/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Close_LabelInputs */

const en_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Export Dialog`)
};

const fr_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boite de dialogue d'exportation`)
};

const de_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportdialog schließen`)
};

const it_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi finestra di dialogo Esporta`)
};

const ru_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть диалоговое окно экспорта`)
};

const es_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el cuadro de diálogo de exportación`)
};

const zh_cn2_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭导出对话框`)
};

const ja_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートダイアログを閉じる`)
};

const hi_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात संवाद बंद करें`)
};

const pt_pt2_transcript_export_close_label = /** @type {(inputs: Transcript_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar caixa de diálogo de exportação`)
};

/**
* | output |
* | --- |
* | "Close Export Dialog" |
*
* @param {Transcript_Export_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_close_label = /** @type {((inputs?: Transcript_Export_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_close_label(inputs)
	if (locale === "de") return de_transcript_export_close_label(inputs)
	if (locale === "it") return it_transcript_export_close_label(inputs)
	if (locale === "ru") return ru_transcript_export_close_label(inputs)
	if (locale === "es") return es_transcript_export_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_close_label(inputs)
	if (locale === "ja") return ja_transcript_export_close_label(inputs)
	if (locale === "hi") return hi_transcript_export_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_close_label(inputs)
	return en_transcript_export_close_label(inputs)
});